

import BpHistoryComp from "./component"
import {fetchBpHistoryRequest,fetchBpPaymentOptionRequest,fetchBpUnLinkRequest} from "./action"
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import {  toast } from 'react-toastify';
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import NoInternet from "../../NoInterNet/component";
const BpHistoryContainer=(props)=>{
   const { makeApiRequest } = useApiRequest()
  const navigate=useNavigate()
  const machineId=localStorage.getItem('machineId')
  const navigator=useNavigate()
  const [loader,setLoader]=useState(false)
 // logger.log("useParams",useParams())
  const {uId} =useParams()
    const [unlinkModal,setUnlinkModal]=useState(false)
    const [bpHistory,setBpHistory]=useState([])
    const [requestsumbitted,setRequestsumbitted]=useState(false)
    const [paymentOptionsList,setPaymentOptionsList]=useState()
    const [finalAmount,setFinalAmount]=useState(20)

    const now = new Date();

const options = { timeZone: 'Asia/Kolkata' };
const indiaDateTimeStr = now.toLocaleString('en-IN', options);

//logger.log(indiaDateTimeStr); 


  // ✅ Offline state — drives the NoInternet screen
  const [noInternet, setNoInternet] = useState(false);


        const handleNetworkError = (error) => {
    if (error.code === "ERR_NETWORK" || !error.response) {
      setNoInternet(true);
      setLoader(false);
      return true;
    }
    return false;
  };


    
        // ─── Online / offline listeners ───────────────────────────────────────────

  useEffect(() => {
    if (!navigator.onLine) {
      setNoInternet(true);
      setLoader(false);
    }

    const goOffline = () => setNoInternet(true);
    const goOnline = () => {
      setNoInternet(false);
      //setLoader(true);
    BpHistory()
        fetchPaymentOption()
 

    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

 
    useEffect(()=>{
        BpHistory()
        fetchPaymentOption()
    },[])
    useEffect(() => {
      //logger.log("CONSOLE NUMBER ->> 3");
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    }, []);

    const UnLinkModalfun=()=>{
      setUnlinkModal(true)
    }
    const handlePaymentSuccess = (response) => {
      //Webwalasocket(OrderId)
      //logger.log('Payment successful:', response);
      // Implement any additional logic for handling payment success here
    };


    const fetchPaymentOption = () => {
      const UserJWTAuth = localStorage.getItem('UserJWTAuth');
      const machineId = localStorage.getItem('machineId');



              makeApiRequest({
     
        url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/payment/option?&balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`,
      
       method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
        },
        data:{"request":{}},
 
      handleSuccess: (response) => handleResponseBpPaymentOption(response),
      handleError: handleErrorBpPaymentOption,
    });
    

    };
    

const handleErrorBpPaymentOption=(error)=>{
  if(error.response.status==401 || error.response.status==403){

   
    //Logout
    //localStorage.removeItem("UserJWTAuth")
      navigate("/login");
}
else{ toast.error(`${error.response.data.status.code}`, {
  position: "top-right",
  autoClose: 1000,
});
}

}

const  handleResponseBpPaymentOption=(response)=>{
  localStorage.setItem("BpBalance",response&&response.data&&response.data.data[2].balance)
  setPaymentOptionsList(response.data.data);

}






const BpUnlink = () => {


  if(!(paymentOptionsList&&paymentOptionsList[2].reason=="UNLINK_REQUESTED"))
  {


    setUnlinkModal(false)
    const uuid = localStorage.getItem('uuid');
    const UserJWTAuth = localStorage.getItem('UserJWTAuth');

        makeApiRequest({
     
        url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/business-profile/deregister`,
      method: "POST",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
        },
        data:{"request":{"sourcePlatform":"web","x-device-id":uuid}},
 
      handleSuccess: (res) => handleResponseBpUnlink(res),
      handleError: handleErrorBpUnlink,
    });




  }
  else{
    setRequestsumbitted(true)
    setUnlinkModal(false)
    fetchPaymentOption()
  }


};

const handleResponseBpUnlink=(response)=>{
  if(response.data && response.data.status === "FAILURE"){
response&&response.data&&toast.error(`${response.data.statusMessage}`, {
  position: "top-right",
  autoClose: 1000,
});
  }
  if(response.data && response.data.status === "SUCCESS"){
    toast.success(`Request Submitted Successfully`, {
      position: "top-right",
      autoClose: 1000,
    });
    navigator("/paymentOptions")
  }
  //logger.log("Get response fetchTagList",response.data.response);
  //
  
}

const handleErrorBpUnlink=(response)=>{
 
}






const BpHistory = () => {

  const UserJWTAuth = localStorage.getItem("UserJWTAuth");

  const machineId = localStorage.getItem('machineId');
  let utcD,utcM,utcMM,utcSS,utcHH
  const currentDate = new Date();
  const utcDate = currentDate.getUTCDate();
  const utcMonth = currentDate.getUTCMonth() + 1; // Months are zero-based, so we add 1
  const type = typeof utcMonth;
  //logger.log("type",type);
  //logger.log("utcDate ",String(utcDate).length)
  if(String(utcDate).length==1){
    utcD="0"+utcDate
   // logger.log("utcDate",utcD)
  }
  else{
    utcD=utcDate
  }
 
  if(String(utcMonth).length==1){
  utcM="0"+utcMonth
    //logger.log("utcM--->",utcM)
  }
  else{
    utcM=utcMonth
  }
  const utcYear = currentDate.getUTCFullYear();
  //logger.log("my date",`${utcMonth}-${utcD}-${utcYear}`); // Output: '5/12/2023' (format: MM/DD/YYYY)

// Get UTC time
const utcHours = currentDate.getUTCHours();
const utcMinutes = currentDate.getUTCMinutes();
const utcSeconds = currentDate.getUTCSeconds();
if(String(utcMinutes).length==1){
utcMM="0"+utcMinutes
//logger.log("utcMM",utcMM)
}
else{
utcMM=utcMinutes
}


if(String(utcSeconds).length==1){
utcSS="0"+utcSeconds
//logger.log("utcMM",utcMM)
}
else{
utcSS=utcSeconds
}


if(String(utcHours).length==1){
utcHH="0"+utcHours
//logger.log("utcMM",utcMM)
}
else{
utcHH=utcHours
}

  
let diffUtcM,diffUtcY
if((utcM-1>0)){

  diffUtcM=utcM-1
  if(String(diffUtcM).length==1){
    diffUtcM="0"+diffUtcM
      //logger.log("diffUtcM--->",diffUtcM)
    }
    else{
      diffUtcM=diffUtcM
    }
  diffUtcY=utcYear
}
else{

  diffUtcM=12
  diffUtcY=utcYear-1

}

  //logger.log("currentDatecurrentDate",`${utcYear}-${utcM}-${utcD} ${utcHH}:${utcMM}:${utcSS}`)

  
   // logger.log("UserJWTAuth",UserJWTAuth)


                 makeApiRequest({
      
        url: `${process.env.REACT_APP_API_BASE_URL}/consumer/api/v1/user/order/history`,  
      method: "POST",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
        },
        data:  {
      "from":`${diffUtcY}-${diffUtcM}-${utcD} ${utcHH}:${utcMM}:${utcSS}`,"to":`${utcYear}-${utcM}-${utcD} ${utcHH}:${utcMM}:${utcSS}`,"pgId":8
             
  },
 
      handleSuccess: (response) => handleResponseBpHistory(response),
      handleError: handleErrorBpHistory,
    });


};


const handleResponseBpHistory=(response)=>{
  setBpHistory(response.data);
}

const  handleErrorBpHistory=()=>{

  
}
 

  //if (noInternet) return <NoInternet />;



    return(
        <BpHistoryComp
        bpHistory={bpHistory}
        unlinkModal={unlinkModal}
        setUnlinkModal={setUnlinkModal}
        BpUnlink={BpUnlink}
        UnLinkModalfun={UnLinkModalfun}
        requestsumbitted={requestsumbitted}
        setRequestsumbitted={ setRequestsumbitted}
        paymentOptionsList={paymentOptionsList}
        />


    )
}

  
  export default BpHistoryContainer;

